/**
 * Routes the soft-redirect country lookup through the storefront's own origin.
 *
 * geolocation.bundle.js calls https://ip.ecom.umgapps.com/ip/lookup, which
 * allow-lists origins and only answers https://xo.store. Every regional
 * subdomain (jp/us/ca/gb/de/fr/au.xo.store) is served no
 * Access-Control-Allow-Origin header, so the fetch fails as a CORS error,
 * countryISOCodeGlobal is never assigned, and the soft redirect never appears
 * for anyone.
 *
 * Shopify fronts storefronts with Cloudflare, so /cdn-cgi/trace answers on our
 * own origin with the visitor's country. Being same-origin it needs no CORS
 * preflight and is not intercepted by the consent manager. Only
 * window.GeoLocation.callGeo is swapped out, so the vendor bundle is untouched
 * and this file can be deleted outright once the upstream allow-list covers the
 * subdomains.
 *
 * The trace endpoint reports no city. The bundle forwards city to the
 * geolocation_detected analytics event, so that field goes empty; country
 * matching never reads it.
 */
(function () {
  'use strict';

  var TRACE_URL = '/cdn-cgi/trace';
  var ISO_PATTERN = /^[A-Z]{2}$/;

  if (!window.GeoLocation || typeof window.GeoLocation.callGeo !== 'function') {
    return;
  }

  var upstream = window.GeoLocation.callGeo.bind(window.GeoLocation);

  function traceCountry(text) {
    var values = {};
    text
      .trim()
      .split('\n')
      .forEach(function (line) {
        var separator = line.indexOf('=');
        if (separator > 0) {
          values[line.slice(0, separator)] = line.slice(separator + 1);
        }
      });
    return values.loc;
  }

  function countryName(iso) {
    var language = (document.documentElement.lang || 'en').split('-')[0];
    try {
      return new Intl.DisplayNames([language], { type: 'region' }).of(iso) || iso;
    } catch (error) {
      return iso;
    }
  }

  window.GeoLocation.callGeo = function () {
    return fetch(TRACE_URL, { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('trace responded ' + response.status);
        }
        return response.text();
      })
      .then(function (text) {
        var iso = traceCountry(text);
        // Cloudflare reports T1 for Tor and XX for networks it cannot place.
        if (!iso || !ISO_PATTERN.test(iso)) {
          throw new Error('trace carried no usable country');
        }
        return { countryISOCode: iso, country: countryName(iso), city: '' };
      })
      .catch(function () {
        // Falls back to the upstream API, which still works on the xo.store apex.
        return upstream();
      });
  };
})();
